(function ($, Drupal, drupalSettings) {
  'use strict';

  Theme.all = function (common, options) {
    // Héritage
    this.common = common;

    // Selecteurs
    this.selectors = {
      // EXEMPLES : Data,Hover; Focus...
    };

    // Éléments
    this.elements = {
      html: $('html'),
      body: $('body'),
      blockGalery: $('.paragraph--type--block-galery .galery--content'),
      blockSlider: $('.paragraph--type--block-slider'),
      blockTestimonials: $('.paragraph--type--block-testimonials'),
    };

    // Variables
    this.toggleMenu = undefined;
    this.rellax = undefined;
    this.fixer = undefined;
  };

  Theme.all.prototype = {
    init: function () {
      this.initMenuMain();
      this.initContextualLinks();
      this.initAnchor();
      this.initBlockGalery();
      this.initBlockSlider();
      this.initBlockTestimonials();
      this.initBlockFaq();
      this.initBlockVideo();
      this.initBlockReinssurance();
      this.initBlockArticles();
      this.initBlockProducts();
      /*this.initSlidersForMobile(
          '.view-display-latest-news .view-list--wrapper'
      );*/
      this.initSliderPageProduct();
      this.initProductsBrowser();
      this.initSliderBrowser();
      this.initFormContact();
      this.initSearch();
      this.initResponsiveTable();

      // optionnel (désactivé) :
      // this.initEffectsOnScroll();
    },

    load: function () {
      console.log('load');
      this.initSlidersForMobile();
    },

    autoload: function (options) {
      console.log('autoload');
    },

    /**
     * Block Menu Main
     */
    initMenuMain: function () {
      /** Menu desktop **/
      $('body').on('mouseover touch focus', '#block-menu-main .level0--link', function (e) {
        e.preventDefault();

        var level0Item = $(this).closest('.level0--item');

        if (!level0Item.hasClass('hover')) {
          $(this).closest('.level0').find('.level0--item.hover').removeClass('hover');
          //level0Item.removeClass('inactive').addClass('hover');
          //$(this).closest('.level0').find('.level0--item:not(.hover)').addClass('inactive');
          level0Item.addClass('hover');
          $('body').addClass('with-menu-collapsed');
        }
      });
      $('body').on('mouseover touch', function(e) {
        if (!e.target.closest('.header-site--inner')) {
          if ($('#block-menu-main .level0--item.hover').length) {
            setTimeout(function () {
              //$('#block-menu-main .level0--item').removeClass('hover').removeClass('inactive');
              $('#block-menu-main .level0--item').removeClass('hover');
              $('body').removeClass('with-menu-collapsed');
            }, 300);
          }
        }
      });

      /** Menu mobile **/
      /* construction du menu mobile */
      $('#block-menu-main').after($('#block-menu-main').clone().attr('id', 'block-menu-main-mobile'));

      // suppression des spans en trop
      $('#block-menu-main-mobile .menu_link_content > ul').unwrap();
      $('#block-menu-main-mobile .level0--link > span, #block-menu-main-mobile .level1--link > span').each(function () {
        $(this).parent().html($(this).html());
      });
      /* déplacement autres menus dans menu mobile */
      $('#block-menu-main-mobile .level0').append($('#block-menu-shortcuts .level0--item').clone());
      $('#block-menu-main-mobile > ul').append('<li class="menu-main-mobile--footer"></li>');

      if ($('#block-webform-newsletter').length) {
        $('.menu-main-mobile--footer').append($('#block-webform-newsletter').clone().attr('id', 'block-webform-newsletter-mobile'));
        $('#block-webform-newsletter-mobile #edit-consentement-newsletter').attr('id', 'consentement_newsletter-mobile');
        $('#block-webform-newsletter-mobile #edit-consentement-newsletter-mobile + option').attr('for', 'consentement_newsletter-mobile');
      }

      $('.menu-main-mobile--footer').append($('#block-menu-social-media').clone().attr('id', 'block-menu-social-media-mobile'));

      const menu = new MmenuLight(
        document.querySelector("#block-menu-main-mobile"),
        "(max-width: " + (BREAKPOINT_LAPTOP - 1) + "px)"
      );
      const navigator = menu.navigation({
        title:  'Vitalac',
        theme:  'light',
        selected: 'active'
      });
      const drawer = menu.offcanvas({
        position: 'left'
      });

      // clone de la recherche en haut du menu
      $('.mm-ocd__content').prepend($('#search-header-form').clone().attr('id', 'search-header-form-mobile'));

      /*document.querySelector('.btn-open-menu-mobile').addEventListener('click', ( evnt ) => {
          evnt.preventDefault();
          drawer.open();
      });*/
      $('.btn-open-menu-mobile').on('click touch', function (e) {
        e.preventDefault();
        $(this).addClass('hide');
        $('.btn-close-menu-mobile').removeClass('hide');
        drawer.open();
      });
      $('.btn-close-menu-mobile').on('click touch', function (e) {
        e.preventDefault();
        $(this).addClass('hide');
        $('.btn-open-menu-mobile').removeClass('hide');
        drawer.close();
      });

      /** Header sticky **/
      if ($(window).scrollTop() > 0) {
        $('body').addClass('with-menu-sticky');
      }
      $(window).on('scroll', function () {
        if ($(window).scrollTop() > 0) {
          if (!$('body:not(.home)').hasClass('with-menu-sticky')) {
            $('body:not(.home) .header-site').css('height', $('.header-site--wrapper').innerHeight());
          }
          $('body').addClass('with-menu-sticky');
        }
        else {
          $('body').removeClass('with-menu-sticky');
        }
      });
    },
    /**
     * Block Galery
     */
    initBlockGalery: function () {
      var self = this;

      if (self.elements.blockGalery.length) {
        self.elements.blockGalery.each(function () {
          var galeryImages = $(this);
          galeryImages.imagesLoaded( function() {
            galeryImages.masonry({
              // options
              //columnWidth: self.elements.blockGalery.find('.paragraph--type--block-image')[1],
              horizontalOrder: true,
              percentPosition: true
            });
          });
        });
      }
    },

    /**
     * Block Slider
     */
    initBlockSlider: function () {
      var self = this;

      if (self.elements.blockSlider.length) {
        self.elements.blockSlider.each(function () {

          // récup param autoplay
          var autoplayTimeout = 0;
          $(this).attr('class').split(' ').forEach(function (item) {
            if (item.indexOf('autoplay-') >= 0) {
              switch (item.replace('autoplay-', '')) {
                case 'slow' :
                  autoplayTimeout = 10000;
                  break;
                case 'fast' :
                  autoplayTimeout = 3000;
                  break;
                case 'normal' :
                  autoplayTimeout = 5000;
                  break;
                default :
                  autoplayTimeout = 0;
              }
            }
          });

          // slide video
          $(this).on('click touch', '.link-video-embed.open-here', function (e) {
            e.preventDefault();

            $(this).addClass('hide');

            // stop autoplay sur le slider
            if ($(this).closest('.block-slider--content').hasClass('owl-carousel')) {
              $(this).closest('.block-slider--content').trigger('stop.owl.autoplay');
            }

            // lecture video
            $(this).closest('.paragraph--type--item-slider-slide').find('.content-video-embed').html('<iframe src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen="1" allow="autoplay; fullscreen; encrypted-media"></iframe>');
            $(this).closest('.paragraph--type--item-slider-slide').addClass('play-video');
          });

          // init slider
          $(this).find('.block-slider--content').addClass('owl-carousel').owlCarousel({
            loop: true,
            autoplay: (autoplayTimeout > 0),
            autoplayTimeout: autoplayTimeout,
            responsiveClass: true,
            autoplayHoverPause: true,
            nav: $(this).hasClass('arrows'),
            navText: [
              '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg></div>',
              '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg></div>'
            ],
            dots: $(this).hasClass('dots'),
            autoWidth: false,
            items: 1,
            onChange: function (event) {
              //console.log(event.property.name);
              // si navigation dans slider en pause  suite à une lecture d'une vidéo : restart autoplay et stop vidéo
              if (event.property.name == 'position') {
                // restart autoplay
                if ($(event.target).autoplay) {
                  $(event.target).trigger('play.owl.autoplay');
                }

                // stop video
                //console.trace($(event.target));
                $(event.target).find('.paragraph--type--item-slider-slide').removeClass('play-video');
                $(event.target).find('.paragraph--type--item-slider-slide .content-video-embed').empty();
                $(event.target).find('.link-video-embed.hide').removeClass('hide');
              }
            }
          });
        });
      }
    },

    /**
     * Block Testimonials
     */
    initBlockTestimonials: function () {
      var self = this;

      self.elements.blockTestimonials.each(function () {
        if ($(this).find('.paragraph--type--item-testimonials-testimony').length > 1) {
          $(this).find('.block-testimonials--content').addClass('owl-carousel').owlCarousel({
            loop: true,
            autoplay: true,
            responsiveClass: true,
            autoplayHoverPause: true,
            nav: true,
            navContainer : $(this).find('.owl-custom-nav'),
            dotsContainer : $(this).find('.owl-custom-dots'),
            navText: [
              '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg></div>',
              '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg></div>'
            ],
            dots: true,
            autoWidth: false,
            items: 1,
            margin: 1,
          });
        }
      });
    },

    /**
     * Block Reassurance
     */
    initBlockReinssurance: function () {
      var containerReinssurance = $('.paragraph--type--container-reinssurance .paragraph--row:not(.nb-col-1)');
      var params = {
        loop: true,
        autoplay: true,
        responsiveClass: true,
        nav: false,
        dots: false,
        autoWidth: false,
        margin: 20,
        responsive : {
          0 : {
            items: 1.2
          },
          768 : {
            items: 2.2
          }
        }
      };

      if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
        containerReinssurance.addClass('owl-carousel').owlCarousel(params);
      }
      $(window).resize(function() {
        if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
          if (!containerReinssurance.hasClass('owl-carousel')) {
            containerReinssurance.addClass('owl-carousel').owlCarousel(params);
          }
        } else {
          if (containerReinssurance.hasClass('owl-carousel')) {
            containerReinssurance.trigger('destroy.owl.carousel').removeClass('owl-carousel');
          }
        }
      });
    },

    /**
     * Block Articles
     */
    initBlockArticles: function () {
      var containerArticles = $('.paragraph--type--container-articles .paragraph--row:not(.nb-col-1)');
      var params = {
        loop: true,
        autoplay: true,
        responsiveClass: true,
        nav: false,
        dots: false,
        autoWidth: false,
        margin: 20,
        responsive : {
          0 : {
            items: 1.2
          },
          768 : {
            items: 2.2
          }
        }
      };

      if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
        containerArticles.addClass('owl-carousel').owlCarousel(params);
      }
      $(window).resize(function() {
        if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
          if (!containerArticles.hasClass('owl-carousel')) {
            containerArticles.addClass('owl-carousel').owlCarousel(params);
          }
        } else {
          if (containerArticles.hasClass('owl-carousel')) {
            containerArticles.trigger('destroy.owl.carousel').removeClass('owl-carousel');
          }
        }
      });
    },

    /**
     * Block PRoducts
     */
    initBlockProducts: function () {
      var containerProducts = $('.paragraph--type--container-products .paragraph--row:not(.nb-col-1)');
      var params = {
        loop: true,
        autoplay: true,
        responsiveClass: true,
        nav: false,
        dots: false,
        autoWidth: false,
        margin: 20,
        responsive : {
          0 : {
            items: 1.2
          },
          576 : {
            items: 2.2
          }
        }
      };

      if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
        containerProducts.addClass('owl-carousel').owlCarousel(params);
      }
      $(window).resize(function() {
        if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
          if (!containerProducts.hasClass('owl-carousel')) {
            containerProducts.addClass('owl-carousel').owlCarousel(params);
          }
        } else {
          if (containerProducts.hasClass('owl-carousel')) {
            containerProducts.trigger('destroy.owl.carousel').removeClass('owl-carousel');
          }
        }
      });
    },

    /**
     * Blocks Sliders for mobile
     */
    initSlidersForMobile: function (el) {
      var containerBlocks = $(el);
      var params = {
        loop: true,
        autoplay: false,
        responsiveClass: true,
        nav: false,
        dots: false,
        autoWidth: false,
        items: 1.2,
        margin: 20
      };

      if ($(window).outerWidth() < BREAKPOINT_TABLET) {
        containerBlocks.addClass('owl-carousel').owlCarousel(params);
      }
      $(window).resize(function() {
        if ($(window).outerWidth() < BREAKPOINT_TABLET) {
          if (!containerBlocks.hasClass('owl-carousel')) {
            containerBlocks.addClass('owl-carousel').owlCarousel(params);
          }
        } else if (containerBlocks.hasClass('owl-carousel')) {
          containerBlocks.trigger('destroy.owl.carousel').removeClass('owl-carousel');
        }
      });
    },

    /**
     * Block FAQ
     */
    initBlockFaq: function () {
      $('body').on('click touch', '.paragraph--type--block-faq .field_question', function (e) {
        e.preventDefault();
        $(this).addClass('selected');
        $(this).closest('.paragraph--type--block-faq').find('.field_question:not(.selected)').removeClass('active');
        $(this).removeClass('selected').toggleClass('active');
      });
    },

    /**
     * Block video
     */
    initBlockVideo: function () {
      $('body').on('click touch', '.paragraph--type--block-video-embed .block-video-embed--link.open-here', function (e) {
        e.preventDefault();
        $(this).closest('.paragraph--type--block-video-embed').find('.block-video-embed--content').html('<iframe src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen="1" allow="autoplay; fullscreen; encrypted-media"></iframe>');
        $(this).closest('.paragraph--type--block-video-embed').addClass('play');
      });
    },

    /**
     * Block slider page product
     */
    initSliderPageProduct: function () {
      let imagesWrapper = $('.page-node-type-product .product-header .field_images');

      if (imagesWrapper.length) {
        let displayThumbnail = (imagesWrapper.find('.image-product').length > 1);
        let blockSliderProducts = imagesWrapper.find('.field_images--wrapper');


        // construction des miniatures
        if (displayThumbnail) {
          imagesWrapper.append('<div class="thumbnail-gallery" />')
          imagesWrapper.find('.image-product').each(function () {
            imagesWrapper.closest('.field_images').find('.thumbnail-gallery').append($(this).clone());
          });

          blockSliderProducts.on('translate.owl.carousel', function (event) {
            let thumbItem = $(this).closest('.field_images').find('.thumbnail-gallery .image-product');
            thumbItem.removeClass('active');
            thumbItem.eq($(this).data('owl.carousel').relative(event.item.index)).addClass('active');
          });

          blockSliderProducts.on('initialized.owl.carousel', function (e) {
            $(this).closest('.field_images').addClass('withThumbnail')
              .find('.thumbnail-gallery .image-product').eq(0).addClass('active');
          });

          // init slider
          blockSliderProducts.addClass('owl-carousel').owlCarousel({
            loop: true,
            autoplay: true,
            responsiveClass: true,
            autoplayHoverPause: true,
            nav: true,
            navText: [
              '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg></div>',
              '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg></div>'
            ],
            dots: false,
            autoWidth: false,
            items: 1
          });

          $('body').on('click touch', '.thumbnail-gallery .image-product', function(e) {
            e.preventDefault();
            $(this).closest('.field_images').find('.thumbnail-gallery .image-product').removeClass('active');
            $(this).closest('.field_images').find('.field_images--wrapper').trigger('to.owl.carousel', [$(this).index()]);
            $(this).addClass('active');
          });
        }

        $('body').on('click touch', '.thumbnail-gallery .image-product', function(e) {
          e.preventDefault();
          $(this).closest('.field_images').find('.thumbnail-gallery .image-product').removeClass('active');
          $(this).closest('.field_images').find('.field_images--wrapper').trigger('to.owl.carousel', [$(this).index()]);
          $(this).addClass('active');
        });
      }

    },

    /**
     * Block products browser
     */
    initProductsBrowser: function () {
      // onglets
      $('body').on('click touch', '.paragraph--type--container-products-browser .field_tabs .tab--link', function (e) {
        e.preventDefault();
        let currentTab = $(this).attr('href');

        $(this).closest('.field_tabs').find('.tab--link').removeClass('active');
        $(this).closest('.field_tabs').find('.tab--content').removeClass('active');

        $(this).addClass('active');
        $(currentTab).addClass('active');
      });

      // champ select
      $('body').on('click touch', '.paragraph--type--item-products-browser-links .btn', function (e) {
        e.preventDefault();

        let strUrl = $(this).closest('.field_links').find('.form-select option:selected').data('href');

        if (strUrl != "") {
          document.location.href = strUrl;
        }
      });

      // mode mobile
      $('body').on('click touch', '.paragraph--type--container-products-browser .field_tabs .tab--content-title', function (e) {
        if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
          e.preventDefault();
          $(this).closest('.tab--content').toggleClass('unfolded');
        }
      });
    },

    /**
     * Block slider browser
     */
    initSliderBrowser: function () {
      // onglets
      $('body').on('click touch', '.paragraph--type--container-slider-browser .field_slider_tabs .tab--link', function (e) {
        e.preventDefault();

        if ($(window).outerWidth() >= BREAKPOINT_TABLETHOR) {
          let currentTab = $(this).attr('href');

          $(this).closest('.field_slider_tabs').find('.tab--link').removeClass('active');
          $(this).closest('.field_slider_tabs').find('.tab--content').removeClass('active');

          $(this).addClass('active');
          $(currentTab).addClass('active');
        }
      });
    },

    /**
     * Init form contact
     */
    initFormContact: function () {
      if ($('.webform-contact .contact-push')) {
        this.refreshFormContact();

        $(window).on('scroll', function () {
          var all = Drupal.Theme.load('all');
          all.refreshFormContact();
        });
      }
    },

    /**
     * Refresh form contact
     */
    refreshFormContact: function () {
      if ($('.contact-push').length && $(window).outerWidth() >= BREAKPOINT_TABLETHOR) {
        var topPushContact = $('.contact-push').offset().top;
        var heightHeader = $('.header-site--wrapper').outerHeight();

        console.log($(window).scrollTop() + parseInt(heightHeader) + "--" + parseInt(topPushContact));

        if (($(window).scrollTop() + parseInt(heightHeader) >= parseInt(topPushContact)) &&
          ($(window).scrollTop() + parseInt(heightHeader) + parseInt($('.contact-push--wrapper').outerHeight())) < parseInt($('.footer-page').offset().top)) {
          if (!$('.contact-push--wrapper').hasClass('sticky')) {
            $('.contact-push--wrapper').addClass('sticky').css('top', heightHeader);
          }
        } else {
          $('.contact-push--wrapper').removeClass('sticky').css('top', 'unset');
        }
      }
    },

    /**
     * Barre de recherche
     */
    initSearch: function () {
      $('.site-search .form-search').prop('autocomplete', 'off');

      $('body').on('click touch', '#block-header-search .link-search', function (e) {
        e.preventDefault();

        if (!$('#block-header-search').hasClass('unfolded')) {

          var objSearch = $('#block-header-search').offset();
          var objHeaderSite = $('.header-site--wrapper').offset();
          $('#block-header-search')
            .css('top', objSearch.top - objHeaderSite.top)
            .css('left', objSearch.left - objHeaderSite.left);
          $('#block-header-search').addClass('unfolded');
        }

        $('.site-search .form-search').focus();
      });
      /*$('body').on('mouseover', '#block-header-search', function (e) {
        e.preventDefault();
        if (!$(this).hasClass('unfolded')) {

          var objSearch = $('#block-header-search').offset();
          var objHeaderSite = $('.header-site--wrapper').offset();
          $('#block-header-search')
            .css('top', objSearch.top - objHeaderSite.top)
            .css('left', objSearch.left - objHeaderSite.left);
          $(this).addClass('unfolded');
        }
      });
      $('body').on('mouseleave', '#block-header-search', function (e) {
        e.preventDefault();
        if (!$(this).hasClass('entered')) {
          $(this).removeClass('unfolded');
          $('#block-header-search')
            .css('top', '')
            .css('left', '');
        }
      });*/
      $('body').on('click touch focus', '.site-search .form-search', function (e) {
        e.preventDefault();
        $('#block-header-search').addClass('entered');
      });
      $('body').on('click touch', '#block-header-search .btn-close', function (e) {
        e.preventDefault();
        $('#block-header-search').removeClass('entered').removeClass('unfolded');
        $('#block-header-search')
          .css('top', '')
          .css('left', '');
      });
    },

    /**
     * Responsive table
     */
    initResponsiveTable: function () {
      try {
        $('.wysiwyg table').each(function () {
          let currentTable = $(this);
          $(this).find('thead th').each(function (index) {
            let colHead = $(this);
            $(this).closest('table').find('tbody tr').each(function () {
              let cols = $(this).find('td');
              cols.eq(index).attr('data-label', colHead.text());
              currentTable.addClass('table-responsive');
            });
          });
        });
      }
      catch (e) {
        return e;
      }
    },

    /**
     * Contextual links
     */
    initContextualLinks: function () {
      // items
      var strContextualLinks = '';
      $('.paragraph-root').each(function () {
        if ($(this).attr('id') && $(this).attr('data-label'))
          strContextualLinks += '<li><a href="#' + $(this).attr('id') + '" id="contextual-link--' + $(this).attr('id') + '">' + $(this).attr('data-label') + '</a></li>';
      });
      if (strContextualLinks != '') {
        // menu contextuel inexistant
        if ($('.contextual-menu').length <= 0) {
          $('.field_reference').prepend('<div class="contextual-menu"><div class="contextual-menu--wrapper"><ul class="contextual-menu--list">' + strContextualLinks + '</ul></div></div>');
        }
        // menu contextuel déjà existant (node product)
        else {
          $('.contextual-menu .contextual-menu--list').prepend(strContextualLinks);
        }

        //$('.contextual-menu').attr('data-init-offset-top', $('.contextual-menu').offset().top);
        //$('.contextual-menu').attr('data-init-height', $('.contextual-menu--wrapper').outerHeight());

        $('.contextual-menu .contextual-menu--wrapper').on('click touch', function (e) {
          if ($(window).outerWidth() < BREAKPOINT_TABLET) {
            $(this).closest('.contextual-menu').toggleClass('collapsed');
          }
        });
        $('.contextual-menu .contextual-menu--list a').on('click touch', function (e) {
          if (!$(this).closest('li').hasClass('active')) {
            var target = $(this).attr('href');

            if (target.startsWith('#')) {
              e.preventDefault();
              //var topAnchor = $(target).offset().top - parseInt($('.header-site').outerHeight()) - parseInt($('.contextual-menu').attr('data-init-height'));
              var topAnchor = $(target).offset().top - parseInt($('.header-site--wrapper').outerHeight()) - parseInt($('.contextual-menu--wrapper').outerHeight());

              $('html, body').stop().animate({scrollTop: topAnchor}, 400);
            }
          }
        });

        // refresh
        this.refreshContextualLinks();

        $(window).on('scroll', function () {
          var all = Drupal.Theme.load('all');
          all.refreshContextualLinks();
        });
      }
    },

    /**
     * refreshContextualLinks
     */
    refreshContextualLinks: function () {
      var all = Drupal.Theme.load('all');
      var menuContextualTop = $('.contextual-menu').offset().top; //$('.contextual-menu').attr('data-init-offset-top');
      var menuContextualHeight = $('.contextual-menu--wrapper').outerHeight(); //$('.contextual-menu').attr('data-init-height');

      // items
      /*console.log($(window).scrollTop() + '+' + $('.header-site').outerHeight());
      console.log($('.contextual-menu').offset().top);
      console.log(($(window).scrollTop() + $('.header-site').outerHeight()) +'>='+ menuContextualTop);*/

      if (($(window).scrollTop() + $('.header-site--wrapper').outerHeight()) >= menuContextualTop) {
        $('.contextual-menu').css('height', menuContextualHeight);
        $('.contextual-menu--wrapper').css('top', $('.header-site--wrapper').outerHeight());
        $('body').addClass('contextual-menu-sticky');
      }
      else {
        $('.contextual-menu').css('height', 'auto');
        $('.contextual-menu--wrapper').css('top', 'auto');
        $('body').removeClass('contextual-menu-sticky');
      }

      //var deltaTop = parseInt($('.header-site--wrapper').outerHeight()) + parseInt($('.contextual-menu').attr('data-init-height'));
      var deltaTop = parseInt($('.header-site--wrapper').outerHeight()) + parseInt($('.contextual-menu--wrapper').outerHeight());
      var activeLink = "";
      var links = $('.contextual-menu .contextual-menu--wrapper a[id]').get().reverse();
      $(links).each(function () {
        var idLink = '#' + $(this).attr('id');
        var paragRoot = $(idLink.replace('contextual-link--', '')).closest('.paragraph-root');

        if (all.isScrolledIntoView(paragRoot, deltaTop)) {
          activeLink = idLink;
        }
      });

      if (activeLink != "") {
        $('.contextual-menu .contextual-menu--wrapper li.active').removeClass('active');
        $(activeLink).closest('li').addClass('active');
      }
    },

    /**
     * isScrolledIntoView
     */
    isScrolledIntoView: function (elem, deltaTop){
      var win = $(window);
      var viewport = {
        top : win.scrollTop() + deltaTop,
        left : win.scrollLeft()
      };
      viewport.right = viewport.left + win.width();
      viewport.bottom = viewport.top + win.height() - deltaTop;

      var bounds = elem.offset();
      bounds.right = bounds.left + elem.outerWidth();
      bounds.bottom = bounds.top + elem.outerHeight();

      //var deltaTop = parseInt($('.header-site--wrapper').outerHeight()) + parseInt($('.contextual-menu').attr('data-init-height'));
      var deltaTop = parseInt($('.header-site--wrapper').outerHeight()) + parseInt($('.contextual-menu--wrapper').outerHeight());

      /*console.log(elem.prop('id'));
      console.log('top:' + viewport.top +'>'+ bounds.bottom);
      console.log('bottom:' + viewport.bottom +'<'+ bounds.top);*/

      return (!(
        viewport.right < bounds.left ||
        viewport.left > bounds.right ||
        viewport.bottom < bounds.top + (win.height()/4) ||
        viewport.top + deltaTop > bounds.bottom
      ));
    },

    /**
     * refreshContextualLinks
     */
    initAnchor: function () {
      let tabAnchor = document.location.href.split('#');

      if (tabAnchor.length > 1) {
        let target = $('#' + tabAnchor[1]);
        if (target.length) {
          let topAnchor = target.offset().top - parseInt($('.header-site--wrapper').outerHeight());
          console.log(topAnchor);
          $('html, body').stop().animate({scrollTop: topAnchor}, 400);
        }
      }
    },


    /**
     * initEffectsOnScroll  (optionnel)
     * Requiert scrollreveal : à activer dans site.json ("./node_modules/scrollreveal/dist/scrollreveal.min.js")
     */
    /*initEffectsOnScroll: function (){
      var optionReset = false;
      var optionDelay = 200;
      var options;
      var delai;

      // animation des titres
      options = { reset: optionReset, delay: 0, duration: 800, distance: '50px', origin: 'left', opacity: 0, interval: 150 };
      ScrollReveal().reveal(
          '.effects-enabled .content-page-header--wrapper .title1, ' +
          '.effects-enabled .content-page-header--wrapper .field_header_text',
          options
      );
      options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'bottom', opacity: 0 };
      ScrollReveal().reveal('.effects-enabled .paragraph--type--item-container-header', options);

      // animation des chiffres
      options = {reset: optionReset, delay: 0, duration: 600, origin: 'bottom', opacity: 0,
          afterReveal: function (el) {
              var all = Drupal.Theme.load('all');
              all.animateNumber($(el));
          }
      };
      ScrollReveal().reveal('.effects-enabled .wysiwyg .numerator', options);

      // animation des icônes réseaux sociaux du footer
      options = {reset: optionReset, delay: optionDelay, duration: 1000, origin: 'bottom', opacity: 0, scale: 1.5 };
      ScrollReveal().reveal($('.effects-enabled').closest('body').find('#block-menu-social-media .level0--item'), options);

      // animation des cards se trouvant dans des vues
      options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
      ScrollReveal().reveal($('.effects-enabled .views-element-container .view-list--wrapper > .view-item'), options);

      // animation des questions de la faq
      options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'right', opacity: 0, interval: 200 };
      ScrollReveal().reveal($('.effects-enabled .paragraph--type--block-faq .field_question'), options);

      // animation pour les boutons
      options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 100 };
      ScrollReveal().reveal($('.effects-enabled .paragraph-root .btn, .paragraph-root .button'), options);

      // animation paragraphe citation
      options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'bottom', opacity: 0, scale: 1.5, interval: 200 };
      ScrollReveal().reveal(
          $('.effects-enabled .paragraph--type--block-citation .field_sentence'),
          options
      );
      options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
      ScrollReveal().reveal(
          $('.effects-enabled .paragraph--type--block-citation .field_author, ' +
              '.effects-enabled .paragraph--type--block-citation .field_author_title'),
          options
      );

      // animation alternée des paragraphes roots
      var cptParagraphRoot = 0;
      $('.effects-enabled .paragraph-root').each(function (index) {

          // animation pour paragraphe de type "2 colonnes"
          if ($(this).hasClass('paragraph--type--container-2col') ||
              $(this).hasClass('paragraph--type--container-2wysiwyg') ||
              $(this).hasClass('paragraph--type--container-faq') ||
              $(this).hasClass('paragraph--type--container-image-text') ||
              $(this).hasClass('paragraph--type--container-video-text')) {

              // sous paragraphes
              $(this).find('.paragraph--row > *').each(function (index) {
                  if ($(this).closest('.paragraph-root').hasClass('display-rtl')) {
                      var origin = (index % 2 == 0 ? 'right' : 'left');
                  }
                  else {
                      var origin = (index % 2 == 0 ? 'left' : 'right');
                  }
                  options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
                  ScrollReveal().reveal($(this), options);
              });
          }
          // animation pour paragraphe contenant des cards
          else if ($(this).hasClass('paragraph--type--container-3col') ||
              $(this).hasClass('paragraph--type--container-4col') ||
              $(this).hasClass('paragraph--type--container-reinssurance') ||
              $(this).hasClass('paragraph--type--container-content-custom')) {
              options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
              ScrollReveal().reveal($(this).find('.paragraph--row .paragraph--type--block-card'), options);
          }

          // animation pour paragraphe chronologie
          else if ($(this).hasClass('paragraph--type--container-chronology')) {
              // sous paragraphes
              $(this).find('.chronology--item-text').each(function (index) {
                  var origin = (index % 2 == 0 ? 'left' : 'right');
                  options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
                  ScrollReveal().reveal($(this), options);
              });
          }

          // animation pour paragraphe galery
          else if ($(this).hasClass('paragraph--type--container-galery')) {
              options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
              ScrollReveal().reveal($(this).find('.paragraph--type--block-image'), options);
          }
          // animations pour paragraphes de type "multilignes"
          else if ($(this).hasClass('paragraph--type--container-col2-texts')) {
              cptParagraphRoot++;

              // sous paragraphes
              $(this).find('.container-col2-texts--content > li').each(function (index) {
                  var origin = (index % 2 == 0 ? 'right' : 'left');
                  options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
                  ScrollReveal().reveal($(this), options);
              });
          }
          // animation pour autres paragraphes
          else if (!$(this).hasClass('paragraph--type--container-wysiwyg') &&
              !$(this).hasClass('paragraph--type--container-citation') &&
              !$(this).hasClass('paragraph--type--container-webform')) {
              cptParagraphRoot++;

              var origin = (index % 2 == 0 ? 'right' : 'left');
              options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
              ScrollReveal().reveal($(this), options);
          }
      });
    },*/

  };

}(jQuery, Drupal, drupalSettings));

